import { createContext } from "react";

const ModuleContext = createContext({ componentName: "" });

export default ModuleContext;
